import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ProgramApplication } from './program-application.model';
import { FORM_ID } from './program-form.service';
import { BaseRestApiService } from '@shared/services/base-rest-api.service';
import { RestApiWrapperService } from '@shared/services/rest-api-wrapper.service';
import { ProgramApplicationFormConstant } from './program-application-form.constant';

@Injectable({
  providedIn: 'root'
})
export class ProgramApplicationFormService extends BaseRestApiService {
  http: HttpClient;

  constructor(_restApiWrapperService: RestApiWrapperService) {
    super(_restApiWrapperService);
  }

  getForm(programId: string, applicationId: string, programFormId = 'PRE_QUALIFICATION'): Observable<any> {
    return this.get(ProgramApplicationFormConstant.form.detail(programId, applicationId, programFormId))
      .pipe(map(result => JSON.parse(JSON.stringify(result))));
  }

  saveProgramApplicationForm(programId: string, applicationId: string, programFormId: FORM_ID, formJson: {}): Observable<any> {
    const file = new File([JSON.stringify(formJson)], 'program-application', {type: 'text/json'});
    const formData = new FormData();
    formData.append('file', file);
    return this.post(ProgramApplicationFormConstant.form.detail(programId, applicationId, programFormId), formData);
  }

  updateInvestorComments(programId: string, applicationId: string, body: any): Observable<ProgramApplication> {
    return this.put(ProgramApplicationFormConstant.form.updateComment(programId, applicationId), body)
      .pipe(map(result => new ProgramApplication(result)));
  }
}
